// packages
import * as yup from 'yup';

// types
import { RecurrenceRule } from './RecurrencePatternBuilder.types';

// utils
import i18n from 'config/i18n';
import { getLocale } from 'utils/date';
import { RecurrenceRangeTypeRequest } from 'generated/index';
import dayjs from 'dayjs';
import { ISO_DATE_REGEX } from 'constants/misc';

const t = i18n.getFixedT(getLocale());

const dayIndexSchema = yup
  .array()
  .of(yup.number().oneOf([0, 1, 2, 3, 4, 5, 6]))
  .default([]);
const recurrenceRuleSchema = yup
  .mixed<RecurrenceRule>()
  .default('none')
  .test((_, context) => !!context.parent.recurrenceRule);
const recurrengeRangeTypeSchema = yup
  .mixed<RecurrenceRangeTypeRequest>()
  .default('END_ON_DATE')
  .test((_, context) => !!context.parent.recurrenceRangeType);

const schema = yup.object({
  recurrenceRule: recurrenceRuleSchema,
  recurrenceRangeType: recurrengeRangeTypeSchema,
  recurrenceInterval: yup
    .number()
    .min(1, t('validation.greaterThan', { field: 0 }))
    .default(1),
  daysSelected: dayIndexSchema.when('recurrenceRule', {
    is: 'weekly',
    then: (schema) => schema.min(1, t('atLeastOneDayRequired'))
  }),
  recurrenceCount: yup.number().optional(),
  recurrenceEnd: yup
    .string()
    .matches(ISO_DATE_REGEX)
    .default(dayjs().add(1, 'month').toISOString())
});

export default schema;
